module.exports = __webpack_public_path__ + "static/media/blue1.a5110582.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/blue1.svg
// module id = 510
// module chunks = 31